import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Table,
  VStack,
  Badge,
  Strong,
  Text,
  Center,
  Box
} from "@chakra-ui/react";
import { UserListSkeleton } from "../Components/custom/Skeletons/UserListSkeleton";
import { CustomPagination } from "../Components/custom/CustomPagination";
import ToggleButton from "../Components/ui/ToggleButton";
import { deletedUsersList } from "../Redux/Action/deletedUsers/deletedusers";
import { updateUserStatus } from "../Redux/Action";
import { getLocalStorageItem } from "../Utils/Helper";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const DeletedUsers = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Deleted Users");
  }, []);

  const dispatch = useDispatch();

  const [deletedUsers, setDeletedUsers] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [totalPagesCount, setTotalPagesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowCount, setRowCount] = useState(10);
  const [refetch, setRefetch] = useState(false);

  const whitelabelLocalStorage = getLocalStorageItem("whitelabelData");

  useEffect(() => {
    setIsDataLoading(true);

    let payload;
    if (whitelabelLocalStorage !== null) {
      const whitelabelID = whitelabelLocalStorage._id;
      payload = { currentPage, rowCount, whitelabelID };
    } else {
      payload = { currentPage, rowCount };
    }

    dispatch(
      deletedUsersList({
        payload,
        callback: (res) => {
          if (res?.meta?.message === 200) {
            setDeletedUsers(res?.data?.users || []);
            setTotalPagesCount(res?.data?.totalPages || 0);
          }
          setIsDataLoading(false);
        },
      })
    );
  }, [refetch, currentPage]);

  const handleUserStatus = (user) => {
    dispatch(updateUserStatus({
      status: 1,
      id: user?._id,
      callback: (res) => {
        if (res?.meta?.code === 200) {
          handlerefetchData();
        }
      }
    }));
  };

  const handlerefetchData = () => setRefetch(!refetch);

  return (
    <VStack spacing={4}>
      {isDataLoading ? (
        <UserListSkeleton />
      ) : (
        <Box
          overflow="auto"
          height="calc(100vh - 250px)"
          width="100%"
          borderRadius="md"
          bg="white"
          boxShadow="sm"
        >
          <Table.Root size="sm" variant="unstyled" width="100%">
            <Table.Header>
              <Table.Row bg="gray.100">
                <Table.ColumnHeader textAlign="center">User Name</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Balance</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Account No.</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Mobile</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Promo Code</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">KYC</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Password</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Status</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="left">Add User</Table.ColumnHeader>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {deletedUsers.length === 0 ? (
                <Table.Row borderBottom={"none"}>
                  <Table.Cell colSpan={9} textAlign="center" py={6}>
                    <Text fontSize="sm" color="gray.500">
                      No data to display.
                    </Text>
                  </Table.Cell>
                </Table.Row>
              ) : (
                deletedUsers.map((user) => (
                  <Table.Row key={user._id}>
                    <Table.Cell textAlign="center">
                      <Strong>{user.fname} {user.lname}</Strong>
                      <Text fontSize="xs" color="gray.500">{user.email}</Text>
                    </Table.Cell>
                    <Table.Cell textAlign="center">{user.balance ?? "-"}</Table.Cell>
                    <Table.Cell textAlign="center">{user.accountNo ?? "-"}</Table.Cell>
                    <Table.Cell textAlign="center">{user.mobile ?? "-"}</Table.Cell>
                    <Table.Cell textAlign="center">{user.promoCode ?? "-"}</Table.Cell>
                    <Table.Cell textAlign="center">
                      {user.kycStatus === "verified" ? (
                        <Badge colorScheme="green">Verified</Badge>
                      ) : (
                        <Badge colorScheme="red">Unverified</Badge>
                      )}
                    </Table.Cell>
                    <Table.Cell textAlign="center">********</Table.Cell>
                    <Table.Cell textAlign="center">
                      <Badge colorScheme="red">Deleted</Badge>
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      <ToggleButton
                        onToggle={() => handleUserStatus(user)}
                        toggle={user?.status == 2 && false}
                        identifier={user?._id}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))
              )}
            </Table.Body>
          </Table.Root>
        </Box>
      )}
      <CustomPagination
        totalCount={totalPagesCount}
        current={currentPage}
        setCurrent={setCurrentPage}
        isLoading={isDataLoading}
      />
    </VStack>
  );
};